/* eslint-disable */

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./Form.css";

const Form = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [submited, setSubmited] = useState(false);

  const onSubmit = async (data) => {
    if (submited) {
      return;
    }
    console.log(data);
    const { email, message } = data;
    try {
      const response = await fetch(
        "https://v1.nocodeapi.com/xxx/google_sheets/HoLWWsnwTXUeEvwQ?tabId=requests",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify([[email, message, new Date().toLocaleString()]]),
        }
      );
      await response.json();
      setSubmited(true);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-container">
        <input
          {...register("email", { required: true })}
          className="form-input"
          aria-invalid={!!errors.email}
          type="email"
          placeholder="Email"
        />
        <textarea
          {...register("message", { required: true })}
          className="form-textarea"
          aria-invalid={!!errors.message}
          placeholder="Message"
        />
        {submited && (
          <span className="form-submited">
            We will reply you as soon as possible
          </span>
        )}
        <button
          className={
            submited
              ? "form-submit form-submit--submited"
              : "form-submit form-submit--default"
          }
          type="submit"
        >
          {submited ? "Submited" : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default Form;
